export default "__VITE_ASSET__D3CW05WU__"